import React from "react";
import QRGeneratorForm from "../../components/QRGenerator/QRGeneratorForm";
import * as GenerateQRActions from "../../store/actions/QRGenerator";

const QRGenerator = () => {
    return (
        <QRGeneratorForm />
    );
}

export default QRGenerator;